import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';
import { colors } from '../../tailwind';
import { FormattedMessage, injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Style
import {
  Button,
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Table,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Dashboard.css';
import FontAwesome from 'react-icons/fa';

// Graphql
import UnreadThreadsQuery from './getUnreadThreads.graphql';
import ReservationsQuery from './getAllReservations.graphql';

// Locale

import {
  BackgroundContainer,
  Text,
  Whitespace,
} from '../../components_new/common';
import NewMessages from '../../components_new/dashboard/NewMessages';
import DashboardListings from '../../components_new/dashboard/DashboardListings';
import DashboardReviews from '../../components_new/dashboard/DashboardReviews';

import DashboardListingSummary from '../../components_new/dashboard/DashboardListingSummary';
import moment from 'moment';

class Dashboard extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.func,
    account: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      picture: PropTypes.string,
    }).isRequired,
    allUnreadThreads: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getUnreadThreads: PropTypes.array,
    }),
    siteName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    allUnreadThreads: {
      loading: true,
      getUnreadThreads: [],
    },
    account: {
      userId: null,
      picture: null,
    },
  };

  render() {
    const {
      account: { userId, picture },
      siteName,
    } = this.props;
    const {
      allUnreadThreads: { loading, getUnreadThreads },
      reservations: { getAllReservation },
    } = this.props;
    const reservationsLoading = this.props.reservations.loading;
    const { formatMessage } = this.props.intl;
    let newMessages = [];
    if (!loading) {
      newMessages = getUnreadThreads != null ? getUnreadThreads.length : 0;
    }

    let newReservations = [];
    let reservationCount = 0;
    if (!reservationsLoading) {
      newReservations =
        getAllReservation != null ? getAllReservation.reservationData : 0;
      reservationCount = getAllReservation.count;
    }

    return (
      <BackgroundContainer
        style={{ paddingLeft: '32px', paddingRight: '32px' }}
      >
        <NewMessages
          messages={getUnreadThreads}
          reservations={newReservations}
          loading={loading || reservationsLoading}
          userId={userId}
        />
        <Whitespace />
        <DashboardListingSummary
          reservations={newReservations}
          loading={loading || reservationsLoading}
          reservationCount={reservationCount}
          userId={userId}
        />
        <Whitespace />
        <DashboardReviews
          reviews={[]}
          priorReservations={[]}
          loading={loading || reservationsLoading}
        />
      </BackgroundContainer>
    );

    // return (
    //   <BackgroundContainer>
    //     <NewMessages
    //       messages={messages}
    //       reservations={reservations}
    //       loading={false}
    //     />
    //   </BackgroundContainer>
    // );
  }
}

const mapState = state => ({
  account: state.account.data,
  siteName: 'Yoodlize',
});

const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s),
  connect(
    mapState,
    mapDispatch,
  ),
  graphql(UnreadThreadsQuery, {
    name: 'allUnreadThreads',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
    },
  }),
  graphql(ReservationsQuery, {
    name: 'reservations',
    options: props => ({
      variables: {
        userType: props.userType,
        month: 'all',
        year: moment().year(),
        summary: true,
      },
      fetchPolicy: 'network-only',
      ssr: true,
    }),
  }),
)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js